import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

interface IArgs {
  groupId: number
  fYear: number
  eltType: number
  forceFetch?: boolean
  isRollup: number
}
export const getFinancialDataForGroup = async ({ groupId, fYear, eltType, isRollup }: IArgs) => {
  const url = proxy(`/webservice/590/sp/v3/spJBPELTDataGroup/call`)
  const payload = {
    'p.FYear': fYear,
    'p.GroupId': groupId,
    'p.EltType': eltType,
    'p.IsRollUp': isRollup,
  }
  const [accessToken] = getTokens()
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, payload, headers })
    return response.Rows?.[0] || {}
  } catch (e) {
    Logger.error(e)
    return {}
  }
}
